export class MinimizeIframeNotice {
    constructor(target, url, title, origin) {
        this.type = "minimizeIframe";
        this.target = target;
        this.url = url;
        this.title = title;
        this.origin = origin;
    }
}
